import { render, staticRenderFns } from "./RoomReservationRegistration.vue?vue&type=template&id=28c311c7&scoped=true&"
import script from "./RoomReservationRegistration.vue?vue&type=script&lang=js&"
export * from "./RoomReservationRegistration.vue?vue&type=script&lang=js&"
import style0 from "./RoomReservationRegistration.vue?vue&type=style&index=0&id=28c311c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c311c7",
  null
  
)

export default component.exports